import { faUser } from "@fortawesome/free-solid-svg-icons";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import { getPermissionIDRequired } from "../../helpers/et3-has-permission";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import MenuDropdownItem from "./side-bar-menu/MenuDropdownItem";
import MenuItem from "./side-bar-menu/MenuItem";
import ET3Div from "../../core/et3-div";
import getRoutingStore from "../../stores/routing";

// Khattaba-only sidebar: only the dropdowns/items a khattaba (matchmaker)
// admin uses are rendered. The User list themselves already hidden non-khattaba links.
// Non-khattaba zones (CSR / Auditor / Supervisor / Communications / QA  / Shareholder) have been removed.
const SideBarMenu = withLiteObserverAndTheme<{ isAlert: boolean }>((props) => {
  const userPermissions = getCorePersonalStore().userPermissions.get();
  const { theme, isAlert } = props;
  const { colors } = theme;
  const isManualKhattabaAdmin =
    getCorePersonalStore().isManualKhattabaAdmin.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={840}
      fDirection="column"
      alignItems="flex-end"
      justifyContent="flex-start"
      color={isAlert ? colors.all.red : colors.all.darkSlateGray}
      style={{}}
      onClick={() => {}}
    >
      <MenuDropdownItem
        onPress={() => null}
        visible={userPermissions.indexOf(getPermissionIDRequired("User")) > -1}
        title={i18n.get("USER")}
        icon={faUser}
        options={getRoutingStore().USER_OPTIONS.get()}
        isMenuOpenObservable={getCoreUIStore().userDropdownIsOpen}
      />

      <MenuItem
        visible={
          userPermissions.indexOf(getPermissionIDRequired("Khatabat")) > -1 &&
          isManualKhattabaAdmin
        }
        title={i18n.get("MATCHMAKING")}
        icon={faUser}
        link="/khattabatMatching/searchAnd1O1M"
      />
    </ET3Div>
  );
});
export default SideBarMenu;
